import { render, staticRenderFns } from "./ArticleTabList.vue?vue&type=template&id=7881a624&scoped=true&"
import script from "./ArticleTabList.vue?vue&type=script&lang=ts&"
export * from "./ArticleTabList.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleTabList.vue?vue&type=style&index=0&id=7881a624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7881a624",
  null
  
)

export default component.exports